import React from "react";
import { Screen } from '~common/screen';
import { StyledScreen } from '~common/screen';
import { Styled } from './styled'
import {IPrice} from "~/types/IPrice";
import {usePriceData} from "~/hooks/usePriceData";

interface IStoringCallsProps {
  isLegalPerson?: boolean;
  service?: IPrice;
  stereoService?: IPrice;
}

const StoringCalls: React.FC<IStoringCallsProps> = (props) => {
  const { isLegalPerson, service, stereoService } = props;
  const recordsPrice = usePriceData(isLegalPerson, service)
  const stereoRecordsPrice = usePriceData(isLegalPerson, stereoService)

  return (
    <Screen
      title={<span><StyledScreen.GreenText>Запись</StyledScreen.GreenText> разговоров</span>}
      bottomLine={true}
    >
      <Styled.Container>
        <Styled.Left>
          <Styled.IconWrapp>
            <Styled.IconBg>
              <Styled.IconPlace>
                <img src={process.env.PUBLIC_DIR + '/images/index_page/quality_standarts/icon_1.svg'} />
              </Styled.IconPlace>
            </Styled.IconBg>
          </Styled.IconWrapp>
        </Styled.Left>
        <Styled.Right>
          <Styled.Title>Не знаете как оценить работу менеджера?</Styled.Title>
          <Styled.Text>
            АТС оnlinepbx ведет запись разговоров. Прослушка звонков позволит оценить исполнение скрипта и соответствие стандартам (грамотная речь, вежливость и пр.) <br /><br />
            <strong>Записанные звонки доступны для прослушивания в течение года.</strong><br /><br />
            Вы можете увеличить срок записи до 1 года и подключить стереозапись (актуально при использовании сервиса речевой аналитики).
          </Styled.Text>
          <Styled.Prices>
            <Styled.PricesFirstItem>
              <Styled.PriceTitle>Запись разговоров (монозапись)</Styled.PriceTitle>
              <Styled.Price>{recordsPrice} / 30 дней</Styled.Price>
            </Styled.PricesFirstItem>
            <Styled.PricesItem>
              <Styled.PriceTitle>Стереозапись</Styled.PriceTitle>
              <Styled.Price>{stereoRecordsPrice} / 30 дней</Styled.Price>
            </Styled.PricesItem>
          </Styled.Prices>
          {/*<Styled.Price>540 ₽ / 30 дней</Styled.Price>*/}
        </Styled.Right>
      </Styled.Container>
    </Screen>
  )
}

export { StoringCalls }
